import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea } from 'semantic-ui-react'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'

import Paginations from '../../../config/pagination'
import EntryList from '../../../config/entries'
import {WindowReload, WindowURLClient, WindowLocationClient} from '../../../config/settings'
import Alertmessage from '../../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {insertvalidations} from './validate'


export default function FundingRecordComponent(props) {

	const [alert,setalert] = useState(false);
	const [Alertcontent,setAlertcontent] = useState({});
	function Alertclose(){setalert(false);}
	function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
	function Alertdelete(data){
		if(data.delete==true){
		}
	}


	/* ------------------------------------------
		List with paginations
	---------------------------------------------*/
	const [search, setsearch]  = useState({
			account:'',
	});

	const [list, setlist] = useState([]);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});

	function pagenumberfunction(page){
				TableList(page,search);
		}
		function listreload(){
				TableList(pagenumber,search);
		}
		function searchProcess(){
			  TableList(pagenumber,search);
		}
		function TableList(page,searchstr){

			 setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait...",footer:'none'}});
			 setalert(true);

				let formData = new FormData();
				formData.append('type','list');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
				axios.post('/client/fundingrecord/http.php',formData)
				.then(function (response) {
						let obj = response.data;
						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);
						setalert(false);

				})
				.catch(function (error){
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
					setalert(false);
				});
		}

		function handleSubmitForm(values, props){
			TableList(pagenumber,values);
	  }

	 /* ------------------------------------------
			List with paginations end
		---------------------------------------------*/



	useEffect(()=>{
		TableList(pagenumber,search);
	},[]);


	return (
		<React.Fragment>
      <div className="page-wrapper">
				{alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}

					<div className="panel">
						 <div className="panel-header">Funding Record List</div>
						 <div className="panel-body">
						 	 <div className="table-responsive">
								 <Table celled singleLine unstackable>
									 <Table.Header>
										 <Table.Row>
											 <Table.HeaderCell>Deposit Credit</Table.HeaderCell>
											 <Table.HeaderCell>Trade Ref.No.</Table.HeaderCell>
											 <Table.HeaderCell>Transaction Date</Table.HeaderCell>
											 <Table.HeaderCell>Status</Table.HeaderCell>
										 </Table.Row>
									 </Table.Header>

									 <Table.Body>
												 {list.length==0&&<Table.Row negative><Table.Cell  colSpan='4' textAlign="center">No record found</Table.Cell></Table.Row>}
												 {list.map(function(data, key){
													 return <Table.Row key={key}>
															 <Table.Cell>{data.deposit_credit}</Table.Cell>
															 <Table.Cell>{data.trade_no}</Table.Cell>
															 <Table.Cell>{data.transaction_date}</Table.Cell>
															 <Table.Cell>{data.status}</Table.Cell>
													 </Table.Row>
												 })}
										 </Table.Body>
										 {list.length>0&&
											 <Table.Footer fullWidth>
													 <Table.Row>
													 <Table.HeaderCell colSpan='4'>
															 <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
													 </Table.HeaderCell>
													 </Table.Row>
											 </Table.Footer>
										 }
								 </Table>
								 </div>
						 </div>
					</div>

      </div>
    </React.Fragment>
  )
}
